import { LogManager } from '../../../common';
import { WorkingHoursByRangeDistributionApplicationService } from '../../../core/application/services/working-hours/working-hours-by-range-distribution.service';
import { TeamMetricsCalendarChartAllTimeAveragesAggregateRoot } from '../../../core/domain/aggregates/team-metrics/calendar/team-metrics-calendar-chart-all-time-averages.aggregate-root';
import { WorkingHoursByRangeDistributionAggregateRoot } from '../../../core/domain/aggregates/working-hours/working-hours-by-range-distribution.aggregate.root';
import { WorkingHoursByRangeDistibutionAggregateRootMapper } from '../../../infrastructure/mappers/working-hours/working-hours-by-range-distribution.mapper';
import { WorkingHoursByRangeDistributionRequestDto } from '../../dtos/working-hours/working-hours-by-range-distribution.request.dto';

export class WorkingHoursByRangeDistributionQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: WorkingHoursByRangeDistributionApplicationService
  ) {}

  async execute(
    props: WorkingHoursByRangeDistributionRequestDto
  ): Promise<WorkingHoursByRangeDistributionAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new Error(
        `WorkingHoursByRangeDistributionQuery.execute encountered an error ${error}`
      );
    }
  }
}
